import { Button, Grid, Hidden } from '@material-ui/core';
import { Dispatch, VFC } from 'react';
import { useHooks } from './useHooks';
import { useStyles } from './useStyles';
import { BaseModal } from '../../../molecules/BaseModal';
import LoadingIcon from '../../../atoms/LoadingIcon';
import { UseFormGetValues } from 'react-hook-form';

export type Props = {
  isOpen: boolean;
  setIsOpen: Dispatch<boolean>;
  userId: number;
  getValues: UseFormGetValues<any>;
};

export const CalenderUrlModal: VFC<Props> = props => {
  const { isOpen, setIsOpen, userId, getValues } = props;
  const classes = useStyles();

  const { closeModal, publishedUrl, handleOnClickCopyLink, isLoading } =
    useHooks({
      setIsOpen,
      isOpen,
      userId
    });

  return (
    <BaseModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      handleSubmit={() => {}}
      handleCancelSubmit={closeModal}
      title={'カレンダーURL'}
      isSubmitButton={false}
      isDeleteButton={false}
      isCancelButton={false}
      isCloseIcon={true}
    >
      {isLoading ? (
        <Grid
          container
          alignItems='center'
          justify='center'
          className={classes.loadingContainer}
        >
          <Grid item xs={12} md={12}>
            <LoadingIcon />
          </Grid>
        </Grid>
      ) : (
        <Grid
          container
          xs={12}
          alignItems='center'
          justify='center'
          className={classes.contentsContainer}
        >
          {publishedUrl && publishedUrl !== '' ? (
            <>
              <Grid
                container
                xs={10}
                alignItems='center'
                justify='flex-start'
                className={classes.userTextCoutainer}
              >
                <Grid item xs={3} md={3}>
                  <div className={classes.userTitleText}>担当者</div>
                </Grid>
                <Grid item xs={3} md={3}>
                  <div className={classes.userNameText}>{`${
                    getValues('charge_user_id').label
                  }`}</div>
                </Grid>
              </Grid>
              <Grid container xs={10} alignItems='center' justify='center'>
                <Grid
                  item
                  xs={12}
                  md={12}
                  className={classes.publishedUrlContainer}
                >
                  <div className={classes.publishedUrlTextContainer}>
                    <div>共有リンク</div>
                    <div>
                      <a href={publishedUrl} target='_blank' rel='noreferrer'>
                        {publishedUrl}
                      </a>
                    </div>
                    <div className={classes.copyLinkButtonWrap}>
                      <Button
                        className={classes.copyLinkButton}
                        onClick={handleOnClickCopyLink}
                      >
                        リンクをコピー
                      </Button>
                    </div>
                  </div>
                </Grid>
              </Grid>
            </>
          ) : (
            <Grid
              container
              xs={10}
              alignItems='center'
              justify='center'
              className={classes.alertWrapper}
            >
              データがありません
            </Grid>
          )}
        </Grid>
      )}
    </BaseModal>
  );
};
